import {AdminBucketInfo, AdminBucketInfoDTO, AdminBucketInfoJSON} from "./AdminBucketInfoDTO";

export interface AdminSignboardInfo {
  signboardId: number
  signupKey: string
  signupName: string
  bucketList?: AdminBucketInfo[]
  urlList?: AdminSignboardUrl[]
}

export type AdminSignboardUrl = {
  type: string
  url: string
  urlReplaceStyle: string
  name: string
}

export interface AdminSignboardInfoJSON {
  signboardId: number
  signupKey: string
  signupName: string
  bucketList?: AdminBucketInfoJSON[]
  urlList?: AdminSignboardUrl[]
}

export class AdminSignboardInfoDTO implements AdminSignboardInfo {
  constructor(
    public signboardId: number,
    public signupKey: string,
    public signupName: string,
    public bucketList?: AdminBucketInfo[],
    public urlList?: AdminSignboardUrl[],
  ) {
  }

  static fromJSON(jsonObject: AdminSignboardInfoJSON): AdminSignboardInfoDTO {
    return new AdminSignboardInfoDTO(
      jsonObject.signboardId,
      jsonObject.signupKey,
      jsonObject.signupName,
      jsonObject.bucketList?.map(item => ({...AdminBucketInfoDTO.fromJSON(item)})),
      jsonObject.urlList,
    )
  }
}
